import { render, staticRenderFns } from "./SCG.vue?vue&type=template&id=117ed3c8&scoped=true&"
import script from "./SCG.vue?vue&type=script&lang=ts&"
export * from "./SCG.vue?vue&type=script&lang=ts&"
import style0 from "./SCG.vue?vue&type=style&index=0&id=117ed3c8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ed3c8",
  null
  
)

export default component.exports